const languages =
[
    'fr'
];

export default languages ;